export const dialerEn = {
  title: "Call",
  coming_soon: "Dialer coming soon",
  coming_soon_hint:
    "The dialer will be enabled once the phone connection is ready.",
  start: "Start calling",
  start_hint: "Optional filter for this session",
  filter_trades: "Trades",
  filter_regions: "Regions",
  filters: {
    all_trades: "All trades",
    all_regions: "All regions",
    selected: "%{smart_count} selected",
    search_trades: "Search trades",
    search_regions: "Search regions",
    no_match: "No match",
    loading: "Loading…",
    load_error: "The list could not be loaded. You can still start calling.",
    remove: "Remove %{name}",
    clear: "Clear all",
    callable_title: "Leads you can call right now",
    empty_hint: "Leave empty to call all your leads in priority order.",
    best_now: "Best slot right now: %{trade}",
  },
  softphone_warning: "Your softphone is not verified.",
  softphone_setup: "Set up the phone",
  session: {
    active: "In session · %{duration}",
    calls: "Calls",
    contacts: "Contacts",
    demos: "Demos",
    auto: "Auto-dial",
    pause: "Pause",
    resume: "Resume",
    end: "End session",
    today: "Today",
  },
  card: {
    local_time: "%{time} local time",
    copy: "Copy",
    copied: "Number copied.",
    attempts: "Attempts: %{count}",
    last: "Last: %{outcome} (%{date})",
    next_callback: "Next callback: %{date}",
    assigned: "Assigned to %{name}",
    unassigned: "Unassigned",
    open_full: "Open full record",
    high_quality: "High quality",
    score: "Score %{score}",
    website: "Website: %{url}",
  },
  launch: {
    launched: "Call launched in your softphone…",
    relaunch: "Relaunch",
    dial: "Dial (Enter)",
    countdown: "Dialing in %{seconds} s — Space to cancel",
    blocked:
      "Outside allowed hours (CRTC) for this lead. Next window: %{date}.",
    blocked_holiday:
      "Outside allowed hours (CRTC, public holiday) for this lead. Next window: %{date}.",
  },
  // GAVION granola-calls
  granola: {
    chip: "Granola",
    chip_hint:
      "Granola comes to the front at each call: click back into the CRM to use the keyboard shortcuts again.",
    demo_started: "(demo) Granola note started",
    // GAVION granola phone: by hand, when the browser blocked the automatic note
    open: "Open Granola",
    // GAVION inbound calls: at result time, when the kit cannot stop the note (AUTO_STOP=0)
    stop_reminder: "Stop your Granola note.",
  },
  // GAVION send-fixes: after a call with a conversation, the follow-up email from the CRM (tracked)
  follow_up: {
    text: "Email follow-up for %{name}",
    send: "Send the follow-up",
    dismiss: "Dismiss",
  },
  states: {
    claiming: "Finding the next lead…",
    empty: "No lead to call",
    empty_hint:
      "No lead available right now. Import leads or widen the session filter.",
    next_callback: "Next callback: %{date}",
    to_leads: "See leads and import",
    outside: "Outside calling hours (CRTC). Next window: %{date}.",
    outside_holiday:
      "Outside calling hours (CRTC, public holiday). Next window: %{date}.",
    paused: "Session paused",
    offline: "Offline — results will be sent when you reconnect",
    waiting_online: "Result saved offline. Resuming when you reconnect.",
    claim_failed: "Could not get the next lead.",
    save_failed: "Saving failed.",
    retry: "Retry",
    lease_lost_title: "This lead was released",
    lease_lost_body:
      "The lock expired or was removed. You can still save your call result, or skip.",
    save_anyway: "Save anyway",
    skip: "Skip",
    pause_released: "Paused for more than 10 minutes: the lead was released.",
    demo_deal: "A deal was created for the demo — delete it?",
    delete_deal: "Delete the deal",
    keep_deal: "Keep",
    demo_deal_hint: "This call's result is no longer a demo.",
    announce: "Next lead: %{name}",
    continue_queue: "Continue with the queue",
    cooling_title: "Lead on hold",
    cooling_body: "This lead is on hold — call anyway?",
    cooling_confirm: "Call anyway",
    cooling_cancel: "Skip this lead",
    assigned_to_other: "This lead is assigned to another rep.",
    // GAVION requeue fix: the queue handed back the rep's open call on this lead (no new dial)
    resumed:
      "You already dialled this lead at %{time} without saving an outcome — pick an outcome or Skip.",
    // GAVION requeue fix: leaving the dialer (route, end of session) with a dialled call and no outcome
    no_outcome_title: "No outcome for %{name}. Save an outcome?",
    no_outcome_body:
      "The call was dialled but no outcome is saved. Without one, it goes to “To complete”.",
    no_outcome_choose: "Pick an outcome",
    no_outcome_skip: "Skip this lead",
    no_outcome_leave: "Leave anyway",
  },
  outcomes: {
    no_answer: "No answer",
    voicemail: "Left voicemail",
    talked_callback: "Talked – call back",
    demo_booked: "Demo booked",
    brochure_sent: "Brochure sent",
    not_interested: "Not interested",
    wrong_number: "Wrong number",
    do_not_call: "Do not call",
    skipped: "Skip",
    unlogged: "Not logged",
    note: "Note",
    what_next: "What happens next",
    what_next_none: "No active rule",
  },
  form: {
    note: "Note",
    note_hint: "N to write, Ctrl+Enter to save",
    add_note: "Add a note", // GAVION small fixes: on a phone the note is collapsed
    callback_at: "Callback date and time",
    // GAVION missed-call: no weekend callbacks
    callback_weekdays:
      "Monday to Friday only (not on December 25 or January 1).",
    chips: {
      tomorrow: "Tomorrow %{time}",
      monday: "Monday %{time}",
      next_week: "In 1 week",
    },
    demo_at: "Demo date and time",
    duration: "Duration",
    minutes: "%{n} min",
    attendee_email: "Attendee email",
    // GAVION demo-contact: the attendee becomes a contact of the lead
    attendee_name: "Attendee name",
    attendee_contact_hint: "Added to the lead's contacts with their email.",
    amount: "Estimated amount ($)",
    email: "Email for the brochure",
    reason: "Reason",
    reasons: {
      already_supplier: "Already has a supplier",
      no_budget: "No budget",
      bad_timing: "Bad timing",
      not_decision_maker: "Not the decision maker",
      other: "Other",
    },
    reason_detail: "Detail",
    dnc_confirm: "The prospect asked not to be called again",
    email_consent: "Agreed to receive our emails",
    consent_failed: "The email consent could not be recorded: %{reason}",
    consent_offline: "Consent not recorded (offline) — do it again",
    save: "Save (Ctrl+Enter)",
    cancel: "Cancel (Esc)",
  },
  errors: {
    callback_required: "Enter the callback date and time.",
    callback_in_past: "The callback must be in the future.",
    callback_outside_hours:
      "Outside allowed hours. Next window: %{suggestion}.",
    callback_weekend:
      "No callback on a weekend, December 25 or January 1. Next business day: %{suggestion}.",
    use_suggestion: "Use this slot",
    demo_datetime_required: "Enter the demo date and time.",
    demo_duration_invalid: "Duration: 30, 45 or 60 minutes.",
    email_required: "A valid email is required.",
    reason_required: "Choose a reason.",
    confirmation_required: "Confirm the prospect's request.",
    edit_window_closed: "This result can no longer be changed (24 h).",
    lease_lost: "The lock on this lead was lost.",
    suppressed: "This number is on the Do Not Call list",
    locked: "In progress by %{name}",
    outside_calling_hours: "Outside allowed hours (CRTC)",
    invalid_phone: "Invalid number",
    session_not_active: "No active session.",
    dialer_unavailable: "The dialer is not available.",
    unknown: "Something went wrong.",
    outcome_invalid: "This outcome is not valid.",
    call_not_found: "This call was not found or is not yours.",
    lead_required: "Pick this call's lead first.",
    forbidden: "Admins only.",
    not_found: "Not found.",
    // GAVION off-CRM call
    called_at_required: "Enter when the call happened.",
    called_at_future: "The call cannot be in the future.",
    called_at_too_old: "Only calls from the last 7 days can be logged.",
    off_crm_forbidden: "Your account cannot make calls.",
  },
  queue: {
    later_today: "Later today (%{count})", // GAVION callbacks today
    title: "Queue (%{count})",
    todo: "To complete (%{count})",
    history: "My calls", // GAVION my-calls
    empty: "Queue empty",
  },
  // GAVION my-calls: "My calls" (/appeler/historique)
  history: {
    title: "My calls",
    day: "Day",
    today: "Today",
    yesterday: "Yesterday",
    last_7_days: "Last 7 days",
    date: "Date",
    result: "Outcome",
    all_results: "All outcomes",
    results_selected: "%{smart_count} outcome |||| %{smart_count} outcomes",
    clear_results: "Clear",
    no_result: "No outcome",
    rep: "Rep",
    all_reps: "All",
    loading: "Loading…",
    load_failed: "Could not load the call history.",
    empty: "No calls for this period.",
    seconds: "%{n} s",
    minutes: "%{m} min %{s} s",
    show_more: "Show more",
    show_less: "Show less",
    show_more_label: "Show the full note of the call to %{lead}",
    show_less_label: "Collapse the note of the call to %{lead}",
    pagination: "Calls pagination",
    pick_date: "Choose a date.",
    direction: "Direction",
    directions: { all: "All", outbound: "Outgoing", inbound: "Incoming" },
    direction_label: { outbound: "Outgoing", inbound: "Incoming" },
    range: "%{from}–%{to} of %{total}",
    previous: "Previous",
    next: "Next",
    columns: {
      date: "Date",
      direction: "Direction",
      lead: "Lead",
      contact: "Contact",
      result: "Outcome",
      duration: "Duration",
      note: "Note",
      callback: "Callback",
      rep: "Rep",
    },
  },
  script: {
    title: "Script",
  },
  activity: { title: "History", empty: "No activity" },
  hotkeys: {
    title: "Keyboard shortcuts",
    outcomes: "1–8: outcomes",
    skip: "S: skip",
    note: "N: note",
    enter: "Enter: dial or confirm",
    save: "Ctrl+Enter: save",
    space: "Space: pause or cancel the countdown",
    escape: "Esc: close the form",
    help: "?: show this help",
    objections: "O: search an objection",
  },
  todo: {
    title: "To complete",
    empty: "Nothing to complete.",
    complete: "Complete",
    rep: "Rep",
    all_reps: "All",
    dialog_title: "Complete the call",
    outcome: "Outcome",
    saved: "Outcome saved.",
    loading: "Loading…",
    load_failed: "Could not load the calls to complete.",
    offline: "You are offline: reconnect to save this outcome.",
    load_more: "Load more",
    seconds: "%{n} s",
    columns: {
      date: "Date",
      company: "Company",
      number: "Number",
      duration: "Duration",
      disposition: "VoIP.ms status",
      rep: "Rep",
    },
  },
  lead: {
    call: "Call",
    someone: "another rep",
    locked_by: "In progress — %{name}",
    locked_tooltip: "%{name} is calling this lead",
    dnc_tooltip: "This lead is on the Do Not Call list",
    invalid_phone_tooltip: "The phone number is invalid",
  },
  outbox: {
    rejected_title: "Offline outcomes refused",
    rejected_toast:
      "%{smart_count} offline outcome refused by the server |||| %{smart_count} offline outcomes refused by the server",
    rejected_item: "%{outcome} (call #%{call}) — %{error}",
    rejected_hint: "These calls remain to complete in “To complete”.",
    dismiss: "Got it",
  },
  timeline: {
    edit_outcome: "Edit outcome",
  },
  session_pill: "Call in progress",
  // GAVION contact-call
  // GAVION off-CRM call: « Log a call made outside the CRM » (lead page « ... » menu)
  off_crm: {
    menu: "Log a call made outside the CRM",
    title: "Call made outside the CRM",
    intro:
      "A call made from your cell: its result counts like a dialer call (callback, lead status, stats).",
    when: "When",
    who: "With",
    main_line: "Lead's main line",
    timeline: "Made outside the CRM",
    done: "Call logged",
  },
  contact_call: {
    banner: "Call — %{contact} (%{type}) — %{company}",
    banner_untyped: "Call — %{contact} — %{company}",
    unnamed: "Unnamed contact",
    call: "Call",
    call_label: "Call %{contact} at %{phone}",
    choose_number_label: "Call %{contact}: choose a number",
    calls_title: "Calls",
    no_calls: "No calls to this contact.",
    timeline_to: "To %{contact}",
    // GAVION demo-contact: a demo booked on the main line, its attendee (not a call to him)
    timeline_attendee: "Attendee: %{contact}",
    demo_main_line: "Demo booked on the lead's main line",
    link_invalid:
      "Can't call this contact: the call link is invalid (missing contact or number). No call was placed.",
    unavailable:
      "Can't call this contact: the contact or this number is no longer available. No call was placed.",
    back: "Back",
  },
  // GAVION inbound calls: « Appel entrant » (#/appel-entrant, opened by MicroSIP)
  inbound: {
    title: "Incoming call",
    from: "Call from %{phone}",
    loading: "Looking up the lead…",
    recorded: "Incoming call recorded on %{name}. Granola note opened.",
    reused: "Incoming call already recorded on %{name}.",
    open_lead: "Open the lead",
    open_granola: "Open Granola",
    contact: "Contact: %{name}",
    choose_title: "This number is on several leads: which one is calling?",
    choose: "Choose",
    unknown_title: "Unknown number",
    unknown_hint:
      "No lead or contact has this number. Link the call to an existing lead or create one: the Granola note opens next.",
    associate: "Link to a lead",
    search_placeholder: "Name, city, phone…",
    no_results: "No lead found.",
    create: "Create a lead",
    create_name: "Company name",
    create_phone: "Phone: %{phone}",
    create_submit: "Create and link the call",
    same_name:
      "Several companies have this name: pick one or create a new one.",
    create_anyway: "Create anyway",
    ended: "Call ended (%{duration}).",
    already_logged: "Result already saved: %{outcome}.",
    result: "Incoming call result",
    log_result: "Enter the result",
    saved: "Result saved.",
    none: "No incoming call recorded for this number in the last 4 hours.",
    my_calls: "My calls",
    invalid:
      "Missing, hidden or non North American number (%{raw}): the call is not recorded.",
    errors: {
      forbidden: "Your account cannot record calls.",
      not_found: "This lead or contact no longer exists.",
      invalid_phone: "Invalid number: the call is not recorded.",
      already_logged: "This call's result is already recorded: close this tab.",
      unknown: "Could not record the incoming call. Try again.",
    },
  },
};
